import { render } from "./motogp_info_form.vue?vue&type=template&id=0ca5fd5a"
import script from "./motogp_info_form.vue?vue&type=script&lang=js"
export * from "./motogp_info_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__